export const defaultMultiCharsValue = () => {
    return {
        data : [], // A 2D Array of cells,
        styles : { margin : 5, text_align : 'C', width : 65, font_size : 20 }
    }
}

export const defaultMultiCharsCellValue = () => {
    return {
        type : 'T', // Input (I) or Text (T)
        value : null,
        inp_size : "xxs"
    }
}
